const locales = {
	zh: (): Promise<any> => import('./zh-CN/index'),
	'zh-TW': (): Promise<any> => import('./zh-TW/index')
};

const messages = {
	close: 'close'
};

export default { locales, messages };
